import type { OthersEntity } from '../../others/Others.entity';
import { OthersScreen } from '../../others/OthersScreen';
import type { TRenderScreen, TSettingsScreenOptions } from '../SettingsScreenRendererService';

export function renderOthersScreen(screen: OthersEntity, options: TSettingsScreenOptions): TRenderScreen {
  return () => <OthersScreen stack={options.stack} screen={screen} />;
}
